const employRoutes = [
  {
    path: "/employ",
    name: "",
    meta: {
      title: "취업정보",
      isDynamic: true,
    },
    children: [
      {
        path: "rcmt", // /employ/rcmt
        name: "studentEmployRcrt",
        meta: {
          title: "교내채용",
          menuCd: "STUDENT_RCMT",
          isDynamic: false,
        },
        component: () => import("@/views/student/student-employ/StudentEmployRcrt.vue"),
      },
      {
        path: "rcmt/:id", // /employ/rcmt/:id
        name: "studentEmployRcrtDetail",
        meta: {
          title: "교내채용 상세",
          menuCd: "STUDENT_RCMT",
          isDynamic: false,
        },
        component: () => import("@/views/student/student-employ/StudentEmployRcrtDetail.vue"),
      },
      // {
      //   path: "career", // /employ/career
      //   name: "studentEmployCareer",
      //   meta: {
      //     title: "교내채용",
      //     menuCd: "STUDENT_CAREER",
      //     isDynamic: true,
      //   },
      //   component: () => import("@/views/student/student-employ/StudentCareerSearch.vue"),
      // },
      // {
      //   path: "spec", // /employ/spec
      //   name: "studentEmploySpec",
      //   meta: {
      //     title: "취업스펙",
      //     menuCd: "STUDENT_SPEC",
      //     isDynamic: true,
      //   },
      //   component: () => import("@/views/student/student-employ/StudentEmploySpec.vue"),
      // },
      {
        path: "starter", // /employ/starter
        name: "studentEmployStarter",
        meta: {
          title: "스타터채용",
          menuCd: "STUDENT_RCMT_STARTER",
          isDynamic: false,
        },
        component: () =>
          import("@/views/student/student-employ/externalRcrt/StudentEmployStarter.vue"),
      },
      {
        //@only_inha: 인하대 페이지에서만 사용
        path: "qnet", // /employ/qnet
        name: "studentEmployQnet",
        meta: {
          title: "Q-net 자격정보",
          menuCd: "STUDENT_RCMT_QNET",
          isDynamic: false,
        },
        component: () => import("@/views/student/student-employ/q-net/StudentQnetLicenseIndex.vue"),
      },
      {
        //@only_inha:
        path: "qnet/detail", // /employ/qnet/detail
        name: "studentEmployQnetDetail",
        meta: {
          title: "Q-net 자격정보 상세",
          menuCd: "STUDENT_RCMT_QNET",
          isDynamic: false,
        },
        component: () =>
          import("@/views/student/student-employ/q-net/StudentQnetLicenseDetail.vue"),
      },
      {
        path: "practice", // /employ/practice - 취업정보 하위 독립 메뉴
        name: "studentEmployPractice",
        meta: {
          title: "직업훈련정보",
          menuCd: "STUDENT_WRK_PRTC",
          isDynamic: false,
        },
        component: () =>
          import("@/views/student/student-employ/work24/StudentEmployWrkPractice.vue"),
      },
      {
        //@only_inha:
        path: "wrk",
        name: "studentEmployWrkJobIndex",
        meta: {
          title: "고용24",
          menuCd: "STUDENT_RCMT_WRK",
          isDynamic: false,
        },
        component: () =>
          import("@/views/student/student-employ/work24/StudentEmployWrkJobIndex.vue"),
        children: [
          {
            path: "", // /employ/wrk - 빈 경로는 부모 경로와 매칭
            name: "studentEmployWrkJob",
            component: () =>
              import("@/views/student/student-employ/work24/StudentEmployWrkJob.vue"),
          },
          {
            path: "duty", // /employ/wrk/duty
            name: "studentEmployWrkDuty",
            component: () =>
              import("@/views/student/student-employ/work24/StudentEmployWrkDuty.vue"),
          },
          {
            path: "smallgiant", // /employ/wrk/smallgiant
            name: "studentEmployWrkSmallgiant",
            component: () =>
              import("@/views/student/student-employ/work24/StudentEmployWrkCrop.vue"),
          },
          {
            path: "major", // /employ/wrk/major
            name: "studentEmployWrkMajor",
            component: () =>
              import("@/views/student/student-employ/work24/StudentEmployWrkMajor.vue"),
          },
          {
            path: "job/detail", // /employ/wrk/job/detail/
            name: "studentEmployWrkJobDetail",
            meta: { title: "고용24 직업정보 상세" },
            component: () =>
              import("@/views/student/student-employ/work24/StudentEmployWrkJobDetail.vue"),
          },
          {
            path: "duty/detail", // /employ/wrk/duty/detail/:id
            name: "studentEmployWrkDutyDetail",
            meta: { title: "고용24 직무정보 상세" },
            component: () =>
              import("@/views/student/student-employ/work24/StudentEmployWrkDutyDetail.vue"),
          },
          {
            path: "major/detail/:id",
            name: "studentEmployWrkMajorDetail",
            meta: { title: "고용24 학과정보 상세" },
            component: () =>
              import("@/views/student/student-employ/work24/StudentEmployWrkMajorDetail.vue"),
          },
        ],
      },
    ],
  },
];
export default employRoutes;
